/**
 * Constants Index
 * Centralized exports for all constants and configuration
 */

// API Configuration
export {
  API_URL,
  API_ENDPOINTS,
  buildApiUrl,
  buildEndpointUrl,
  ENV_INFO,
  SOCKET_IO_URL,
} from './api';

// Assets (R2) – import from 'constants/assets' (Metro resolution from barrel is unreliable on Windows)

// Environment Configuration
export { 
  isDevelopment, 
  isProduction, 
  API_CONFIG, 
  CURRENT_CONFIG, 
  APP_CONFIG, 
  USER_CONFIG 
} from './env';

// Debug (opt-in logging)
export { isApiDebugEnabled } from './debug';

// Groups Configuration
export { 
  getDefaultGroups,
  getGroupsForUser,
  getAllGroups
} from './groups';

// Tutorial Configuration
export { tutorialSlides } from './tutorial';

// Avatar Configuration
export { AVATAR_IDS, type AvatarId } from './avatarIds';
export { AVATAR_REGISTRY } from './avatarRegistry';

// Monkey (reserved system user; MONKEY_AVATAR_ID is display-only, not in AVATAR_IDS)
export { MONKEY_USER_ID, MONKEY_AVATAR_ID } from './monkey';

// Public app-store links
export { APP_STORE_URL, GOOGLE_PLAY_URL } from './storeLinks';
